"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

var _mapInstanceProperty = require("@babel/runtime-corejs3/core-js/instance/map");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.mapObservableJsonResponse = void 0;

var _operators = require("rxjs/operators");

var _mapJsonResponse = require("./mapJsonResponse");

var mapObservableJsonResponse = function mapObservableJsonResponse(ajaxObservable, noContentOverride) {
  if (noContentOverride) {
    return ajaxObservable.pipe((0, _mapInstanceProperty(_operators))(_mapJsonResponse.mapJsonResponsePassthrough));
  } else {
    return ajaxObservable.pipe((0, _mapInstanceProperty(_operators))(_mapJsonResponse.mapJsonResponse));
  }
};

exports.mapObservableJsonResponse = mapObservableJsonResponse;